module.exports = __webpack_public_path__ + "static/undraw_secure_data_0rwp-28a6ad04e9f309c46f345a7cf3d4d428.svg";